'use strict';

export default angular
  .module('maestro.directives.common.ng-sub-class', [])

  .directive('ngSubClass', function NgSubClass($parse) {
    return {
      restrict: 'A',
      //require: ['ngSubClassSelector'], // string
      link: function(scope, element, attr) {
        let lastTimeAppliedClasses = [];
        let subClassSelector;

        let parseNgSubClass = $parse(attr['ngSubClass'], toClassString);

        scope.$watch(parseNgSubClass, (newClassString) => {
          applyNewClasses(newClassString);
        });

        attr.$observe('ngSubClassSelector', (newValue) => {
          subClassSelector = newValue;
          let newClassString = parseNgSubClass();
          applyNewClasses(newClassString);
        });

        function applyNewClasses(newClassString) {
          if (!subClassSelector) {
            return;
          }
          let classesToAdd = split(newClassString);
          let classesToRemove = lastTimeAppliedClasses.filter(c => !classesToAdd.some(nc => nc === c));
          if (classesToRemove.length) {
            $(element).find(subClassSelector).removeClass(classesToRemove.join(' '));
          }
          if (classesToAdd.length) {
            $(element).find(subClassSelector).addClass(classesToAdd.join(' '));
          }
          lastTimeAppliedClasses = classesToAdd;
        }
      }
    };

    // Helpers
    function split(classString) {
      return (classString && angular.isString(classString)) ? classString.split(' ') : [];
    }

    function toClassString(classValue) {
      if (!classValue) {
        return classValue;
      }

      let classString = classValue;

      if (angular.isArray(classValue)) {
        classString = classValue.map(toClassString).join(' ');
      } else if (angular.isObject(classValue)) {
        classString = Object.keys(classValue).filter(key => classValue[key]).join(' ');
      } else if (!angular.isString(classValue)) {
        classString = classValue + '';
      }

      return classString;
    }
  })

  .name;
